import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { ActionLink, SVGIcon, Text } from '@custom-components';

const ITEM_HEIGHT = 48;

function OptionsMenu({ options, disabled }) {
  const [anchorEl, setAnchorE1] = useState(null);

  const handleClick = (event) => {
    setAnchorE1(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorE1(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <IconButton
        aria-label="More"
        aria-owns={open ? 'long-menu' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        disabled={disabled}
        size="large">
        <SVGIcon selectedIcon="ellipsis" rotate={90} iconColor={disabled ? '#D8D8D8' : undefined} />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: 200
          }
        }}
      >
        {options.map(({ label, optionDisabled = false, onClick }) => (
          <MenuItem
            key={`option-${label}`}
            disabled={optionDisabled}
            onClick={() => {
              onClick();
              handleClose();
            }}
          >
            <ActionLink disabled={optionDisabled} noPadding>
              <Text.HeadingSixth noMargins>{label}</Text.HeadingSixth>
            </ActionLink>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
OptionsMenu.defaultProps = {
  options: [],
  disabled: PropTypes.bool
};
OptionsMenu.propTypes = {
  options: PropTypes.arrayOf(PropTypes.element),
  disabled: false
};

export default OptionsMenu;
